/* tslint:disable */
/* eslint-disable */
/**
 * Jack Burton Internal API
 * API for the Jack Burton platform
 *
 * The version of the OpenAPI document: v1 App
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime.js';
/**
 * 
 * @export
 * @interface CreateTaskFromSuggestionRequest
 */
export interface CreateTaskFromSuggestionRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateTaskFromSuggestionRequest
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateTaskFromSuggestionRequest
     */
    content?: string;
    /**
     * 
     * @type {Date}
     * @memberof CreateTaskFromSuggestionRequest
     */
    dueDate?: Date;
    /**
     * 
     * @type {number}
     * @memberof CreateTaskFromSuggestionRequest
     */
    priority?: number;
    /**
     * 
     * @type {number}
     * @memberof CreateTaskFromSuggestionRequest
     */
    assignedTo?: number;
}

/**
 * Check if a given object implements the CreateTaskFromSuggestionRequest interface.
 */
export function instanceOfCreateTaskFromSuggestionRequest(value: object): boolean {
    return true;
}

export function CreateTaskFromSuggestionRequestFromJSON(json: any): CreateTaskFromSuggestionRequest {
    return CreateTaskFromSuggestionRequestFromJSONTyped(json, false);
}

export function CreateTaskFromSuggestionRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateTaskFromSuggestionRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'title': json['title'] == null ? undefined : json['title'],
        'content': json['content'] == null ? undefined : json['content'],
        'dueDate': json['dueDate'] == null ? undefined : (new Date(json['dueDate'])),
        'priority': json['priority'] == null ? undefined : json['priority'],
        'assignedTo': json['assignedTo'] == null ? undefined : json['assignedTo'],
    };
}

export function CreateTaskFromSuggestionRequestToJSON(value?: CreateTaskFromSuggestionRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'title': value['title'],
        'content': value['content'],
        'dueDate': value['dueDate'] == null ? undefined : ((value['dueDate'] as any).toISOString()),
        'priority': value['priority'],
        'assignedTo': value['assignedTo'],
    };
}

